import React, { Component } from 'react'
import '../styles/RegisteredOrganizations.css'
import DropdownWidget from '../widgets/DropdownWidget'
import InputSearchWidget from '../widgets/InputSearchWidget'
import ActivityIndicator from '../widgets/ActivityIndicator'
import APIOrganizationRequest from '../api/APIOrganizationRequest'
import APIGenericRequest from '../api/APIGenericRequest'

class RegisteredOrganizations extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			siteId: JSON.parse(localStorage.getItem("siteId")),
			accountType: props.type,
			site: props.site
		}
		this.onRegisterClick = this.onRegisterClick.bind(this)
		this.viewDetails = this.viewDetails.bind(this)
		this.handleSearch = this.handleSearch.bind(this)
		this.filterByARBOType = this.filterByARBOType.bind(this)
		this.filterByDate = this.filterByDate.bind(this)
	}

	viewDetails(id) {
		this.props.viewDetails("view-details", id)
	}

	componentWillMount() {
		this.setState({showActivityIndicator: true})
		const orgs = APIOrganizationRequest.getAllOrganizationsBySiteId(this.state.accessToken, this.state.siteId)
		orgs.then((response) => {
			console.log(response)
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			const partnershipDate = []
			for(const v of response.results.rows) {
				partnershipDate.push(v.partnership_date)
			}
			partnershipDate.sort()
			const pdSorted = {}
			let id = 2
			for(const v of partnershipDate) {
				pdSorted[v] = {id: id++, name: formatDate(v)}
			}
			const pd = []
			pd.push({id: 0, name: "ANY"})
			pd.push({id: 1, name: "CUSTOM"})
			for(const k in pdSorted) {
				pd.push(pdSorted[k])
			}
			const list = response.results.rows
			list.sort((a, b) => {
				return(a.name.localeCompare(b.name))
			})
			this.setState({
				showActivityIndicator: false,
				allOrganizations: list,
				partnershipDate: pd,
				listData: list
			})
		})
	}

	onRegisterClick() {
		this.props.onRegisterClick("registration")
	}

	handleSearch(searchVal) {
		if(searchVal == null) {
			this.setState({listData: null})
			return
		}
		if(this.state.allOrganizations === undefined) {
			return
		}
		const byCity = []
		for(const v of this.state.allOrganizations) {
			if(searchVal.cityId == 0 || searchVal.cityId == null) {
				byCity.push(v)
			}
			else {
				if(searchVal.city === v.city) {
					byCity.push(v)
				}
			}
		}
		const dateSelected = {
			partnershipDate: searchVal.partnershipDate,
			dateFrom: searchVal.dateFrom,
			dateTo: searchVal.dateTo
		}
		if(searchVal.orgTypeId != 0 && searchVal.orgTypeId != null) {
			this.filterByARBOType(searchVal.orgType, byCity, (at) => {
				this.filterByDate(dateSelected, at, (bd) => {
					this.setState({listData: bd})
				})
			})
			return
		}
		this.filterByDate(dateSelected, byCity, (bd) => {
			this.setState({listData: bd})
		})
	}

	filterByARBOType(type, arboTypes, callback) {
		const at = []
		for(const v of arboTypes) {
			if(type === v.arbo_type) {
				at.push(v)
			}
		}
		callback(at)
	}

	filterByDate(dateSelected, arboTypes, callback) {
		const dr = new Date(dateSelected.partnershipDate)
		const df = new Date(dateSelected.dateFrom)
		const dt = new Date(dateSelected.dateTo)
		const frs = []
		for(const v of arboTypes) {
			const ds = new Date(v.partnership_date)
			if(dateSelected.partnershipDate == null) {
				frs.push(v)
				continue
			}
			if(dateSelected.partnershipDate.toLowerCase() === "any") {
				frs.push(v)
			}
			else if(dr.getMonth() === ds.getMonth() && dr.getDate() === ds.getDate() && dr.getFullYear() === ds.getFullYear()) {
				frs.push(v)
			}
			else if(ds >= df && ds < dt) {
				frs.push(v)
			}
		}
		callback(frs)
	}

	render() {
		return(<div id="registered-organizations">
			<div id="ro-search"><SearchOrganizations partnershipDate={this.state.partnershipDate}
				submitSearch={this.handleSearch} /></div>
			<div id="ro-listview"><OrganizationsListView data={this.state.listData}
				onRegisterClick={this.onRegisterClick}
				viewDetails={this.viewDetails} />
			</div>
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
			{/* <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} /> */}
		</div>)
	}
}

class SearchOrganizations extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			siteId: JSON.parse(localStorage.getItem("siteId")),
			maxDate: sessionStorage.getItem("date-today"),
			user: JSON.parse(sessionStorage.getItem("user")),
			orgType: "ANY",
			city: "ANY",
			partnershipDate: "ANY",
			isDisabled: true
		}
		this.getAllCitiesByProvinceId = this.getAllCitiesByProvinceId.bind(this)
	}

	componentWillMount() {
		const allFarmers = APIOrganizationRequest.getAllARBOTypes(this.state.accessToken, this.state.siteId)
		allFarmers.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
			c.push({id: 0, name: "ANY"});
			for(const v of response.results.rows) {
				c.push({id: v.arbo_type_id, name: v.name.toUpperCase()});
			}
			this.setState({orgTypes: c});
		})
		this.getAllCitiesByProvinceId()
	}

	// componentDidUpdate(prevProps) {
	// 	console.log(this.props.partnershipDate)
	// 	if(prevProps.partnershipDate != this.props.partnershipDate) {
	// 		console.log(this.props.partnershipDate)
	// 		let dmin = this.props.partnershipDate[2]
	// 		if(dmin != null) {
	// 			const d = dmin.name.split("/")
	// 			var dateMin = d[2] + "-" + d[0] + "-" + d[1]
	// 		}
	// 		this.setState({dateMin: dateMin})
	// 	}
	// }

	getAllCitiesByProvinceId() {
		const city = APIGenericRequest.getAllCitiesByProvinceId(this.state.accessToken, this.state.user.province_id);
		city.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			c.push({id: 0, name: "ANY"})
			for(const v of response.results.rows) {
				c.push({id: v.city_id, name: v.name})
			}
			this.setState({cities: c,})
		})
	}

	render() {
		return(<div className="search-bar">
			<div>SEARCH BY</div>
			<br/>
			<div style={{'margin-bottom': '5px'}}>ARBO Type</div>
			<DropdownWidget placeholder={this.state.orgType} list={this.state.orgTypes}  onItemSelected={(id, value) => {
				this.setState({
					orgTypeId: id,
					orgType: value,
				})
			}} />
			<br/><br/>
			{/* <div>Municipality</div>
			<DropdownWidget placeholder={this.state.city} list={this.state.cities} cStyle={{'min-width': '100%'}} onItemSelected={(id, value) => {
				this.setState({cityId: id, city: value})
			}} />
			<br/> */}
			<button className="green-two" onClick={(e) => {
				const filter = {
					orgType: this.state.orgType,
					orgTypeId: this.state.orgTypeId,
					partnershipDate: this.state.partnershipDate,
					dateFrom: this.state.dateFrom,
					dateTo: this.state.dateTo,
					city: this.state.city,
					cityId: this.state.cityId
				}
				this.props.submitSearch(filter)
			}}>SEARCH</button>
			<button className="green-two" onClick={(e) => {
				this.setState({
					orgType: "ANY",
					orgTypeId: null,
					partnershipDate: "ANY",
					dateFrom: "",
					dateTo: "",
					city: "ANY",
					cityId: null
				})
				this.props.submitSearch(null)
			}}>CLEAR</button>
		</div>)
	}
}

class OrganizationsListView extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			searchLabel: (props.data != null)? props.data.count + " result(s)": "PRESS THE SEARCH BUTTON TO SEE RESULTS",
			listItems: [],
			onRegisterClick: props.onRegisterClick
		}
		this.viewDetails = this.viewDetails.bind(this)
	}

	viewDetails(id) {
		this.props.viewDetails(id)
	}

	componentDidUpdate(prevProps) {
		if(prevProps.data != this.props.data) {
			const listItems = []
			if(this.props.data != null) {
				for(const v of this.props.data) {
					listItems.push(<ListItem data={v} viewDetails={this.viewDetails} />)
				}
			}
			this.setState({
				searchLabel:  (this.props.data != null)? this.props.data.length + " RESULT(S)": "PRESS THE SEARCH BUTTON TO SEE RESULTS",
				listItems: listItems
			})
		}
	}

	render() {
		return(<div className="organizations-lv">
			<div className="olv-top">
				<InputSearchWidget placeholder="SEARCH RESULTS" cStyle={{'width': '285px'}}
					onSearchClick={(value) => {
						if(this.props.data == null) {
							return
						}
						const sr = searchString(value, this.props.data)
						if(sr == null) {
							return
						}
						const listItems = []
						for(const v of sr) {
							listItems.push(<ListItem data={v} viewDetails={this.viewDetails} />)
						}
						this.setState({
							searchLabel:  sr.length + " RESULT(S)",
							listItems: listItems
						})
					}}
					onEnterPress={(value) => {
						if(this.props.data == null) {
							return
						}
						const sr = searchString(value, this.props.data)
						if(sr == null) {
							return
						}
						const listItems = []
						for(const v of sr) {
							listItems.push(<ListItem data={v} viewDetails={this.viewDetails} />)
						}
						this.setState({
							searchLabel:  sr.length + " RESULT(S)",
							listItems: listItems
						})
					}} />
				<div className="olv-label"><div>{this.state.searchLabel}</div></div>
			</div>
			<div className="olv-header">
				<table className="olv-table-header">
					<col style={{width: '28%'}} />
					<col style={{width: '22%'}} />
					{/* <col style={{width: '11%'}} /> */}
					<col style={{width: '25%'}} />
					<col style={{width: '25%'}} />
					<tr>
						<th>ORGANIZATION NAME</th>
						<th>ARBO TYPE</th>
						{/* <th>PARTNERSHIP DATE</th> */}
						<th>PROVINCE</th>
						<th>MUNICIPALITY</th>
						<div className="olv-grid-btn"><button className="green-two" onClick={(e) => {
								this.state.onRegisterClick()
							}}>ADD ORGANIZATION</button>
						</div>
					</tr>
				</table>
			</div>
			<div className="olv-items">{this.state.listItems}</div>
			{this.state.listItems.length < 1 && <div className="olv-result"><div>NO RESULT</div></div>}
		</div>)
	}
}

function ListItem(props) {
	return(<div className="fc-list-item">
			<table className="fc-table-data">
				<col style={{width: '28%'}} />
				<col style={{width: '22%'}} />
				{/* <col style={{width: '11%'}} /> */}
				<col style={{width: '25%'}} />
				<col style={{width: '25%'}} />
				<tr>
					<td>{props.data.name.toUpperCase()}</td>
					<td>{props.data.arbo_type}</td>
					{/* <td>{formatDate(props.data.partnership_date)}</td> */}
					<td>{props.data.province}</td>
					<td>{props.data.city}</td>
					<div className="olv-grid-btn"><button className="btn-view-details" onClick={(e) => {
							props.viewDetails(props.data.arbo_id)
						}}>VIEW DETAILS</button>
					</div>
				</tr>
			</table>
	</div>)
}

const formatDate = (d) => {
	if(d == null) {
		return
	}
	const date = new Date(d)
	var m = date.getMonth()+1
	if(date.getMonth() < 9) {
		m = "0" + (date.getMonth()+1)
	}
	var dt = date.getDate()
	if(date.getDate() <= 9) {
		dt = "0" + date.getDate()
	}
	return(m + "/" + dt + "/" + date.getFullYear())
}

const searchString = (str, data) => {
	if(data.length < 1) {
		return
	}
	if(str == null) {
		str = ""
	}
	const list = []
	for(const v of data) {
		if(v.name.toLowerCase().includes(str.toLowerCase())) {
			list.push(v)
		}
	}
	return(list)
}

export default RegisteredOrganizations
